(() => {
  const selector = '[data-coutureia-pdp-description-font="normalize"]';

  const normalizeContainer = (container) => {
    const targetFamily = getComputedStyle(container).fontFamily.trim();
    if (!targetFamily) return;

    container.querySelectorAll('*').forEach((element) => {
      element.style.setProperty('font-family', targetFamily, 'important');
    });
  };

  const normalizeWithin = (root = document) => {
    if (root.matches?.(selector)) normalizeContainer(root);
    root.querySelectorAll?.(selector).forEach(normalizeContainer);
  };

  const run = () => normalizeWithin(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', (event) => {
    normalizeWithin(event.target);
  });
})();
